import React,{useState} from 'react';
import Td from '@visa/vds/td';
import Tr from '@visa/vds/tr';
import MCSPagedTable from '../../../components/MCSPagedTable';
import MCSLoading from '../../../components/MCSLoading';
import Icon from '@visa/vds/icon';
import {DateHelper} from '../../../_helpers/DateHelper';
import {AdminRoutes} from '../../../_constants/PageRoutes';
import { useHistory } from 'react-router-dom';
import Link from '@visa/vds/link';
import Badge from '@visa/vds/badge';
import { useAuthContextUser } from 'context/AuthContext';

function ManageOrganizationsTable(props){
    const history = useHistory();
    const user = useAuthContextUser();
    const canExport = user && (user.hasReportingExport || user.isSuperAdmin)

    const [selectedPage,setSelectedPage] = useState(1)
    const [isDsc,setDsc] = useState(false);

    const fetchDataOnPageChange = (page) =>{
        setSelectedPage(page);
        props.fetch(page,props.searchVal,props.ordered,isDsc);
    }

    const handleSearchChange = async (searchBy) =>{
      await props.fetch(1, searchBy,props.ordered,isDsc);
      setSelectedPage(1);
    }

    const sortData = async (orderBy = null , dsc = false) =>{
        let mappedOrderBy = orderBy;
        if (orderBy === "region") {
            mappedOrderBy = "organizationLicensedBusiness.region";
        }

        props.setOrdered(mappedOrderBy);
        setDsc(dsc);
        await props.fetch(selectedPage,props.searchVal,mappedOrderBy,dsc);
    }

    const redirectToManageDetails = (item) =>{
        history.push({
          pathname: AdminRoutes.MANAGEORGANIZATION_DETAILS,
          state:{
            organization: item
          }
        })
    }

    const redirectToFilteredUserPage=(organizationName) =>{
      history.push({
        pathname: AdminRoutes.MANAGEUSERS,
        search: '?organizationName=' + organizationName
      })
    }

    if(!props.fetched){
        return(<MCSLoading/>)
    }
    else{
        return (
        <>
        <MCSPagedTable size={"compact"}
            colHeaders={props.colHeaders}
            useExportAll={canExport} 
            useSearchBar={true}
            ordered={props.ordered}
            setOrdered={props.setOrdered}
            sortData={sortData}
            isDsc={isDsc}
            setDsc={setDsc}
            usePagination={true}
            selectedPage={selectedPage} setSelectedPage={fetchDataOnPageChange} totalPages={props.totalPages}
            handleExportAll={props.handleExportOrganizations}
            searchHelpText={"Search Organization/Licensed Country/BID"}
            searchVal = {props.searchVal} setSearchVal = {props.setSearchVal} handleSearchChange={handleSearchChange}
            tableData={
                props.data && props.data.items.map((row,key)=>(
                <Tr key={key}>
                    <Td>
                      {row.organization.organizationName}&nbsp;{row.organization.isUVID && <Badge type="neutral">UVID</Badge>}&nbsp;
                      {row.hasSubscriptionManagersAssigned && <Badge type="stable">SM</Badge>}
                    </Td>
                    <Td>{row.organization.bid}</Td>
                    <Td>{row.organization.organizationLicensedBusiness?.region ?? row.organization.regionName ?? "-"}</Td>
                    <Td>{row.organization.country.countryName}</Td>
                    <Td>{row.organization.organizationLicensedBusiness && row.organization.organizationLicensedBusiness.licensedCountry}</Td>
                    <Td>{row.organization.lastUpdatedBy}</Td>
                    <Td>{DateHelper.ToLocaleDateString(row.organization.lastUpdatedOn)}</Td>
                    <Td>
                      <Link onClick={() => redirectToFilteredUserPage(row.organization.organizationName)}>
                        {row.totalUsers}
                      </Link>
                      </Td>
                    <Td><Icon onClick={()=>redirectToManageDetails(row.organization)} className="vss-clickable-icon" name="settings" resolution="low" /></Td>
                </Tr>
                ))
            }/>
        </>
        );
    }
  }

export default ManageOrganizationsTable;
